module.exports = __webpack_public_path__ + "static/media/resource-game.03b12008.png";